import type { Level } from "building-types/levels/levelTypes";
import type { WallMassSystem } from "building-types/walls/wallSytemTypes";
import type { RWTable, Table } from "common/data/table";
import type { RoomIdToRoomSetIndexLookup, RoomSetsByLevelId, RoomSetWithLevelId } from "./roomSetTypes";

export function uniqueRoomSetsTables(
  levels: Table<Level>,
  wallMasses: Table<WallMassSystem>,
): {
  roomSets: RoomSetWithLevelId[];
  roomSetsByLevelId: RoomSetsByLevelId;
  roomIdToRoomSetIndexLookup: RoomIdToRoomSetIndexLookup;
} {
  const roomSets: RoomSetWithLevelId[] = [];
  const roomSetsByLevelId: RWTable<RoomSetWithLevelId[]> = {};
  const roomIdToRoomSetIndexLookup: RoomIdToRoomSetIndexLookup = {};

  const visitedFirstRoomId: { [roomId: string]: boolean } = {};
  let roomSetIndex = 0;
  for (const levelId in levels) {
    const roomSetList = wallMasses[levelId].openConnectedRoomSets;
    for (const roomSet of roomSetList) {
      const { id } = roomSet[0];
      if (visitedFirstRoomId[id]) {
        continue;
      } else {
        visitedFirstRoomId[id] = true;

        const roomSetWithLevelId = { levelId, roomSet, id: roomSetIndex };
        roomSets.push(roomSetWithLevelId);
        roomSetsByLevelId[levelId] ||= [];
        roomSetsByLevelId[levelId].push(roomSetWithLevelId);

        for (const roomLike of roomSet) {
          roomIdToRoomSetIndexLookup[roomLike.id] = roomSetIndex;
        }
        roomSetIndex++;
      }
    }
  }
  return { roomSets, roomSetsByLevelId, roomIdToRoomSetIndexLookup };
}
